import React, { FC } from "react";
import { Tick } from "../../assets/images";
import { HandleNext } from "../../types";
import { Link } from "react-router-dom";

const Refund: FC<HandleNext> = ({ handleNext }) => {
  return (
    <div
      className="fixed z-10 inset-0 overflow-y-auto"
      // ref={paymentOptionModal}
    >
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-[90%] mx-auto sm:max-w-[600px]">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="flex flex-col gap-[30px] w-full items-center  justify-center ">
                <img src={Tick} alt="" className=" h-[100px] w-[100px] " />

                <div className="flex flex-col gap-5 w-full">
                  <p className=" text-[#FF276A] font-Jakarta text-[20px] font-medium leading-[150%] text-center ">
                    Please note that your rental will be evaluated for a refund.
                  </p>
                  <p className=" font-Poppins text-[12px] font-normal leading-[150%] text-[#222222] text-center ">
                    It might take up to 1 - 3 business days before you receive
                    the money in your account.
                  </p>

                  <p className=" font-Poppins text-[24px] font-normal leading-[150%] text-[#222222] text-center ">
                    Read about out policy{" "}
                    <Link
                      to="/policies/cancellation-policy"
                      className=" text-lightGreen"
                    >
                      {" "}
                      {""} here
                    </Link>
                  </p>

                  <button
                    type="button"
                    onClick={handleNext}
                    className=" px-5 py-2 mx-auto w-2/5 bg-midGreen rounded-lg font-Poppins font-semibold text-[38px] text-center text-white"
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Refund;
